import { createSlice } from "@reduxjs/toolkit";
import {
  AddCountryAction,
  DeleteCountryAction,
  GetAllCountryAction,
  UpdateCountryAction,
  UpdateDefaultCountryAction,
} from "store/middlewares/dataManagement/country";

// isDeleteMeFulFilled
export const countrySlice = createSlice({
  name: "country",
  initialState: {
    countryLoading: true,
    country: null,
  },
  extraReducers(builder) {
    builder
      .addCase(GetAllCountryAction.pending, (state) => {
        // state.countryLoading = true;
        // state.country = null;
        state.country =
          state.country?.result?.length > 0 ? state.country : null;
      })
      .addCase(GetAllCountryAction.fulfilled, (state, action) => {
        state.countryLoading = false;
        state.country = action.payload.response;
      })
      .addCase(GetAllCountryAction.rejected, (state) => {
        state.countryLoading = false;
        state.country = null;
      })
      // Delete
      .addCase(DeleteCountryAction.fulfilled, (state, action) => {
        // state.countryLoading = false;
        // state.country = {
        //   ...state.country,
        //   total: Number(state.country.total) - 1,
        //   data: state.country?.data?.filter(
        //     (item) => item.id !== action.payload.id
        //   ),
        // };
        state.countryLoading = false;
        state.country = action.payload.response;
      })
      //Update
      .addCase(UpdateCountryAction.fulfilled, (state, action) => {
        state.countryLoading = false;
        state.country = {
          ...state.country,
          result: state.country.result.map((item) =>
            item.id === action.payload.response.id
              ? action.payload.response
              : item,
          ),
        };
      })

      .addCase(UpdateDefaultCountryAction.fulfilled, (state, action) => {
        state.countryLoading = false;
        state.country = {
          ...state.country,
          result: state.country.result.map((item) =>
            item.id === action.payload.response.id
              ? { ...item, ...action.payload.response }
              : { ...item, is_default: false },
          ),
        };
      })

      //Add
      .addCase(AddCountryAction.fulfilled, (state, action) => {
        state.countryLoading = false;
        // state.country = {
        //   ...state.country,
        //   total: Number(state.country.total) + 1,
        //   data: [action.payload.response, ...state.country.data],
        // };
      });
  },
});

export default countrySlice.reducer;
